import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import useGlynt from '../../../hooks/useGlynt';
import { AppContext } from '../../../../App';
import { ToolActionsContext } from '../../../../context/ToolActionsContext';
import { getIdFromUrl } from '../../../../utils/getIdFromUrl';
import { saveAs } from 'file-saver';
import { useParams } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';

function DownloadTokenized({
  docLabel,
  tokenizerVersion,
}: {
  docLabel: string;
  tokenizerVersion: string | undefined;
}) {
  const { setToast, isStaff } = React.useContext(AppContext);
  const { isReview, setOpen } = React.useContext(ToolActionsContext);
  const { did, eid } = useParams<{ did: string; eid: string }>();
  const client = useQueryClient();
  const glynt = useGlynt();
  const docId = isReview ? eid : did;

  const downloadTokenized = () => {
    let listParams = isReview ? { extraction: docId } : { document: docId };
    client.fetchQuery({
        queryKey: ['tokenizedsBy'],
        queryFn: async () => (await glynt).tokenizeds.list(listParams),
      })
      .then((data) => {
        const tokenizedId = isReview
          ? getIdFromUrl(data.results[0].url)
          : getIdFromUrl(
              data.results.filter((tk) => tk.tokenizer_version == tokenizerVersion)[0].url
            );

        if (data.results[0].finished) {
          client.fetchQuery({
              queryKey: ['tokenized'],
              queryFn: async () => (await glynt).tokenizeds.retrieve(tokenizedId),
            })
            .then((data) => {
              const blob = new Blob([JSON.stringify(data)], {
                type: 'application/json;charset=utf-8',
              });
              saveAs(blob, `${docLabel}-tokenized.json`);
            })
            .catch((error) => console.error({ error }));
        } else {
          alert('Tokenization in progress, try again in a few minutes.');
        }
      });
  };

  if (!isStaff) return null;

  return (
    <MenuItem
      sx={{ zIndex: 2000 }}
      data-cy="btn-tool-nav-download-tokenized"
      onClick={async () => {
        setToast({
          open: true,
          message: 'Downloading...',
          variant: 'success',
        });
        if (docId) {
          downloadTokenized();
        }
        setOpen(false);
      }}
    >
      Download tokenized
    </MenuItem>
  );
}

export default DownloadTokenized;
